import { render, staticRenderFns } from "./j4pegIcon.vue?vue&type=template&id=6e92d5f4&"
import script from "./j4pegIcon.vue?vue&type=script&lang=js&"
export * from "./j4pegIcon.vue?vue&type=script&lang=js&"
import style0 from "./j4pegIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports